import { render, staticRenderFns } from "./RolePower.vue?vue&type=template&id=63c0b09a&scoped=true&"
import script from "./RolePower.vue?vue&type=script&lang=js&"
export * from "./RolePower.vue?vue&type=script&lang=js&"
import style0 from "./RolePower.vue?vue&type=style&index=0&id=63c0b09a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c0b09a",
  null
  
)

export default component.exports